export default "__VITE_ASSET__C7zSEQUp__"